export default __webpack_public_path__ + "static/media/advocate-img1.2254cc3c.png";